import React, { createContext, ReactNode, useMemo } from 'react';
import { TFlow } from '../types/types.ts';

export type FlowContextType = {
  market: string;
  config: TFlow;
  counterSteps?: string[];
};

export const FlowContext = createContext<FlowContextType | undefined>(undefined);

export const FlowProvider: React.FC<FlowContextType & { children: ReactNode }> = ({
  market,
  config,
  children,
}) => {
  const counterSteps = useMemo(() => Object.values(config.steps)
    .filter(step => step.isStep)
    .map(step => step.name), [config]);

  return (
    <FlowContext.Provider value={{ market, config, counterSteps }}>
      {children}
    </FlowContext.Provider>
  );
};
